module.exports = __webpack_public_path__ + "img/shapes06.406985f5.svg";